module.exports = __webpack_public_path__ + "img/arabica-txt.79613676.svg";